import useGetApi from 'src/api/useGetApi';
import { keepPreviousData } from '@tanstack/react-query';
import { InboundEmailDTO } from 'src/types/application/InboundEmailDTO';

interface PageInfo {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

interface QueryParams {
  page?: number;
  pageSize?: number;
  search?: string;
  from?: string;
  to?: string;
  subject?: string;
  upn?: string;
}

type ApiResponse = {
  edges: InboundEmailDTO[];
  pageInfo: PageInfo;
};

const useInboundEmails = (params?: QueryParams, enabled?: boolean) => {
  return useGetApi<ApiResponse>({
    endpoint: 'communications/inbound-emails',
    queryParameters: params,
    options: {
      enabled,
      placeholderData: keepPreviousData,
    },
  });
};

export default useInboundEmails;
